import React from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import ContentMobile from './ContentMobile'
import amiImgMobile from './assets/ami_img_mobile.png'
import Content from './Content'
import via0 from './assets/VIA0.png'
import ami_fr from './assets/ami_fr.png'
import ami_en from './assets/ami_en.png'
import ami_de from './assets/ami_de.png'
import ami_ch from './assets/ami_ch.png'
import ami_ja from './assets/ami_ja.png'
import ami_pl from './assets/ami_pl.png'
import ami_pt from './assets/ami_pt.png'
import ami_tr from './assets/ami_tr.png'
import ami_es from './assets/ami_es.png'
import boing from './assets/boing.png'
import { api } from '../index.api'
import { callAnalyticsLink, wrapAnalyticsLinks } from '../../helpers/analytics'
import { PERMISSIONS } from '../../constants'
import { getPermittedOptions } from './BotAssistantUtils'
import { setAssistantActive } from '../../actions/assistant'
import { isAssistantPathEnabled } from '../../pages/functions'
import { getCookie } from '../../helpers/CookieHandler'


import {
  ANALYTICS_LINK_TYPES,
  ANALYTICS_LINK_SECTIONS,
} from '../../constants'

const LANDING_SELECTION = { value: 'Landing' }

const initialState = {
  minimized: false,
  showAssistant: false,
  showDialog: false,
  isLoading: false,
  blah: false,

  selection: LANDING_SELECTION,

  // array of arrays of questions pertaining to category
  questions: null,
  // determines current index of questions
  currentPage: 0,
  paginationMap: null
}

var countrySelected ='';
var affiliateSelected ='';
var userLanguage = getCookie('welcomeLanguage');

class BotAssistantMobile extends React.Component {
  constructor (props) {
    super(props)
    // content language is always English when constructor resolves, but gets updated by componentWillReceiveProps
    this.content = this.props.pageContent.content.module.digitalAssistant
    this.redirectValues = [
      this.content.landing.options[3].value,
      this.content.landing.options[4].value,
      this.content.landing.options[6].value,
      this.content.static.product.options[5].value,
    ]
    initialState.paginationMap = this.initPaginationMapMain(this.content.landing.options.length)
    initialState.permittedLandingOptions = this.content.landing.options
    this.state = initialState

    // keeps track of sequence of selections for breadcrumb nav
    this.selections = []

    // initial variable to determine whether assistant should be enabled
    this.assistantEnabled = false

    // set by API responses
    this.products = null
    this.categories = null
  }

  getPaginationPageSize = marginTop => {
    const browserHeaderAndFooterHeight = 110
    const pageItemHeight = 40.0
    const paginationFooterHeight = 41
    const availableHeight = document.documentElement.clientHeight - browserHeaderAndFooterHeight -
      marginTop - paginationFooterHeight
    return Math.floor(availableHeight / pageItemHeight)
  }

  initPaginationMapMain = landingOptionsLength => {
    const pageSize = this.getPaginationPageSize(205)
    const totalPages = Math.ceil(landingOptionsLength / pageSize)

    const mapItem = {
      pageNumber: 1,
      pageSize: pageSize,
      totalPages: totalPages
    }
    const paginationMap = new Map()
    paginationMap.set('main', mapItem)

    return paginationMap
  }

  initPaginationMapSpecificProduct = (paginationMapKey, categoriesLength) => {
    const pageSize = this.getPaginationPageSize(121)
    const totalPages = Math.ceil(categoriesLength / pageSize)

    const mapItem = {
      pageNumber: 1,
      pageSize: pageSize,
      totalPages: totalPages
    }
    const paginationMap = this.state.paginationMap
    paginationMap.set(paginationMapKey, mapItem)

    return paginationMap
  }

  setPaginationMapItemPageNumber = (paginationMapKey, pageNumber) => {
    const paginationMap = this.state.paginationMap
    const paginationMapItem = paginationMap.get(paginationMapKey)
    paginationMapItem.pageNumber = pageNumber
    paginationMap.set(paginationMapKey, paginationMapItem)
    this.setState({ paginationMap: paginationMap })
  };

  handleBoing = () => {
    this.selections = []
    this.setState(prevState =>
      prevState.minimized
        ? {
          minimized: false,
          showDialog: false,
          selection: LANDING_SELECTION,
          questions: null,
          currentPage: 0,
          paginationMap: this.initPaginationMapMain(this.state.permittedLandingOptions.length)
        }
        : {
          minimized: true
        }
    )
  };

  openFromExternalComponent = () => {
    if (this.state.isLoading || this.state.showDialog) {
      return
    }

    if (this.state.minimized) {
      this.selections = []
      this.setState({
        minimized: false,
        showDialog: true,
        selection: LANDING_SELECTION,
        questions: null,
        currentPage: 0,
        paginationMap: this.initPaginationMapMain(this.state.permittedLandingOptions.length)
      })
    } else {
      this.setState({ showDialog: true })
    }
  }

  handleBack = () => {
    this.selections.pop()
    if (this.selections.length === 0) {
      this.setState({ selection: LANDING_SELECTION })
    } else {
      const selection = this.selections[this.selections.length - 1]
      this.setState({ selection })
      this.handleChoice(selection)
    }
  };

  handleHome = () => {
    this.selections = []
    this.setState({ selection: LANDING_SELECTION, questions: null })
    this.setState({ paginationMap: this.initPaginationMapMain(this.state.permittedLandingOptions.length) })
  };

  handleClose = () => {
    this.setState({ showDialog: false })
  };

  handleOpen = () => {
    callAnalyticsLink(
      ANALYTICS_LINK_TYPES.CUSTOM_LINK,
      ANALYTICS_LINK_SECTIONS.ASSISTANT + 'Open Ami',
      'assistant'
    )
    this.setState({ showDialog: true })
  };

  handleClick = choice => {
    if (choice) {
      if (this.redirectValues.includes(choice.value)) {
        this.handleClose()
        this.handleBoing()
      }
      this.handleChoice(choice)
      this.selections.push(choice)
      this.setState({ selection: choice })
    }
  };

  handleChoice = choice => {
    if (choice.content) {
      return
    }

    // case where product is selected
    if (choice.name && choice.productCode) {
      this.setState({ isLoading: true })
      api.getAssistantCategories(
        {
          productCode: choice.productCode,
          country: this.countrySelected,
          affiliate : this.affiliateSelected
        },
        response => {
          this.categories = response
          this.initPaginationMapSpecificProduct(choice.name, response.length)
          this.setState({ isLoading: false })
        },
        error => {
          throw error
        }
      )
    }
    // Comment Starts
    // case where category is selected
    // if (choice.id || choice.categoryId) {
    //   this.setState({ isLoading: true })
    //   let queryParams
    //   if (choice.categoryId) {
    //     // initial question
    //     queryParams = {
    //       productCode: choice.productCode,
    //       categoryId: choice.categoryId,
    //       parentId: choice.id
    //     }
    //   } else if (choice.id) {
    //     // subsequent questions
    //     queryParams = {
    //       productCode: this.selections[2].productCode,
    //       categoryId: choice.id
    //     }
    //   }
    //   api.getAssistantQuestions(
    //     queryParams,
    //     response => {
    //       const questions = this.paginate(response)
    //       this.setState({ currentPage: 0, questions })
    //       this.setState({ isLoading: false })
    //     },
    //     error => {
    //       throw error
    //     }
    //   )
    // }
    // Comment Ends 
    if (choice.id || choice.categoryId) {
      this.setState({ isLoading: true })
      let queryParams
      if (choice.categoryId) {
        // initial question
        queryParams = {
          productCode: choice.productCode,
          categoryId: choice.categoryId,
          parentId: choice.id,
          country: this.countrySelected,
          affiliate : this.affiliateSelected, 
          userLanguage : this.userLanguage // added for fetching category based on affiliate
        }
      } else if (choice.id) {
        // subsequent questions
        queryParams = {
          productCode: this.selections[2].productCode,
          categoryId: choice.id,
          country: this.countrySelected,
          affiliate : this.affiliateSelected,
          userLanguage : this.userLanguage // added for fetching category based on affiliate
        }
      }
      api.getAssistantQuestions(
        queryParams,
        response => {
          const questions = this.paginate(response)
          this.setState({ currentPage: 0, questions })
          this.setState({ isLoading: false })
        },
        error => {
          throw error
        }
      )
    }
  };

  handleNav = index => {
    if (typeof index === 'undefined') {
      this.handleHome()
      return
    }
    this.selections = this.selections.slice(0, index + 1)
    if (this.selections.length === 0) {
      this.setState({ selection: LANDING_SELECTION })
    } else {
      const selection = this.selections[this.selections.length - 1]
      this.setState({ selection })
      this.handleChoice(selection)
    }
  };

  handlePageForward = () => {
    this.setState(prevState => ({
      currentPage:
        prevState.currentPage === this.state.questions.length - 1
          ? prevState.currentPage
          : prevState.currentPage + 1
    }))
  };

  handlePageBackward = () => {
    this.setState(prevState => ({
      currentPage: prevState.currentPage === 0 ? 0 : prevState.currentPage - 1
    }))
  };

  handlePageNav = currentPage => {
    this.setState({ currentPage })
  };

  // hide/show Assistant based on available window size
  componentDidMount () {
    window.addEventListener('resize', this.checkDimensions.bind(this))
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.checkDimensions.bind(this))
  }

  componentDidUpdate () {
    wrapAnalyticsLinks('.assistant-mobile-container', 'assistant')
  }

  componentWillReceiveProps (nextProps) {
    if (!nextProps.referenceData) {
      return
    }
    const referenceData = nextProps.referenceData.referenceData
    const assistantContent = nextProps.pageContent.content.module.digitalAssistant
    this.countrySelected = referenceData.SelectedCountry.name
    this.affiliateSelected = referenceData.SelectedCountry.affiliate
    if (
      assistantContent && nextProps.permissions.indexOf(PERMISSIONS.ASSISTANT) !== -1
    ) {
      this.assistantEnabled = isAssistantPathEnabled()
      const deviceSizeAllowed = true // document.documentElement.clientWidth > 700 ? true : false;
      if (this.assistantEnabled && deviceSizeAllowed) {
        this.content = assistantContent
        this.redirectValues = [
          assistantContent.landing.options[3].value,
          assistantContent.landing.options[4].value,
          assistantContent.landing.options[6].value,
          assistantContent.static.product.options[5].value,
        ]
        const permittedLandingptions = getPermittedOptions(
          assistantContent.landing.options, nextProps.permissions, referenceData.UserType)
        const paginationMap = this.initPaginationMapMain(permittedLandingptions.length)
        this.setState({
          showAssistant: true,
          paginationMap: paginationMap,
          permittedLandingOptions: permittedLandingptions
        })
        this.props.setAssistantActive(true)
      }
      api.getAssistantProducts(
        referenceData.SelectedCountry.affiliate,
        referenceData.SelectedCountry.name,
        response => {
          const products = []
          for (const i in response) {
            const product = {
              name: response[i].name,
              productCode: response[i].productCode,
              veevaProductCode: response[i].veevaProductCode
            }
            products.push(product)
          }
          this.products = products
        },
        error => {
          throw error
        }
      )
    }
  }

  checkDimensions = () => {
    this.setState({ showAssistant: this.assistantEnabled })
    this.props.setAssistantActive(this.assistantEnabled)

    /* Ran */
    // if (document.documentElement.clientWidth < 700) {
    //   this.setState({ showAssistant: false });
    // } else {
    //   this.setState({ showAssistant: this.assistantEnabled });
    // }
  };

  paginate = questions => {
    if (questions.length <= 4) {
      return [questions]
    }
    const sortedQuestions = []
    let intermediateArr = []
    let i = 0
    for (const idx in questions) {
      intermediateArr.push(questions[idx])
      if (i === 3) {
        sortedQuestions.push(intermediateArr)
        i = 0
        intermediateArr = []
      } else {
        i++
      }
    }
    sortedQuestions.push(intermediateArr)
    return sortedQuestions
  };

  render () {
    const userType = this.props.referenceData ? this.props.referenceData.referenceData.UserType : null
    let imageSrc = "./assets/ami_"+getCookie('welcomeLanguage')+".png"
    let tempImage
    if (imageSrc === './assets/ami_fr.png') {
      tempImage = ami_fr
    } else {
      tempImage = ami_en
    }
    return this.state.showAssistant ? (
      <div className='assistant-mobile-container'>
        <div className='assistant-mobile-toggle'>
          <div className={`toggle-div ${this.state.minimized ? 'hidden' : ''}`}>
            <div style={{ position: 'relative' }}>
              {/* Close div */}
              <div
                style={{
                  zIndex: '3',
                  position: 'absolute',
                  top: '20px',
                  left: '-30px',
                  height: '32px',
                  width: '32px',
                  border: '2px solid white',
                  borderRadius: '16px',
                  backgroundColor: '#2F9ECE'
                }}
                onClick={this.handleBoing}
              >
                <span
                  style={{ color: 'white', fontSize: '22px', padding: '5px 0px 0px 5px' }}
                  className='fa fa-close fa-lg'
                />
              </div>
              {/* The following div is at zIndex 0 under the close div.  Its only purpose is to add the shadow under the x */}
              <div style={{
                zIndex: '1',
                position: 'absolute',
                top: '20px',
                left: '-30px',
                height: '32px',
                width: '32px',
                border: '2px solid white',
                borderRadius: '16px',
                backgroundColor: '#2F9ECE',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.4)'
              }}
              >&nbsp;
              </div>
              {/* Bubble div */}
              <div
                style={{
                  zIndex: '2',
                  position: 'absolute',
                  top: '36px',
                  left: '-222px',
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.4)',
                  paddingLeft: '100px',
                  paddingTop: '10px',
                  height: '67px',
                  width: '211px',
                  border: '2px solid white',
                  borderRadius: '8px',
                  backgroundColor: '#2F9ECE',
                  color: 'white',
                  fontSize: '13px',
                  fontFamily: 'Open Sans'
                }}
                onClick={this.handleOpen}
              >
                <span style={{ fontWeight: 'bold', lineHeight: '18px' }}>Hi, I’m Ami.</span><br />
                <span style={{ fontWeight: 'normal', lineHeight: '18px' }}>Tap me for help!</span>
              </div>
            </div>
          </div>
          <img
            className={`toggle-image ${this.state.minimized ? 'hidden' : ''}`}
            src={amiImgMobile}
            alt='Ami'
            onClick={this.handleOpen}
          />
          <img
            className={`boing ${!this.state.minimized ? 'hidden' : ''}`}
            src={boing}
            alt='Boing'
            onClick={this.handleBoing}
          />
        </div>
        <div
          className={
            this.state.showDialog
              ? 'assistant-mobile-window assistant-mobile-show'
              : 'assistant-mobile-window'
          }
        >
          <Header
            title=''
            onClose={this.handleClose}
            onBack={this.handleBack}
            onHome={this.handleHome}
            selection={this.state.selection}
          />
          {this.state.isLoading ? (
            <div />
          ) : (
            <ContentMobile
              onClick={this.handleClick}
              onClose={this.handleClose}
              onBoing={this.handleBoing}
              onNav={this.handleNav}
              onPageNav={this.handlePageNav}
              onPageBackward={this.handlePageBackward}
              onPageForward={this.handlePageForward}
              currentPage={this.state.currentPage}
              questions={this.state.questions}
              selection={this.state.selection}
              categories={this.categories}
              products={this.products}
              selections={this.selections}
              content={this.content}
              patientContent={this.props.pageContent.content.page.HOME.patient}
              permissions={this.props.permissions}
              userType={userType}
              permittedLandingOptions={this.state.permittedLandingOptions}
              landingSelectionValue={LANDING_SELECTION.value}
              setPaginationMapItemPageNumber={this.setPaginationMapItemPageNumber}
              paginationMap={this.state.paginationMap}
              paginationMapKey={this.state.selection === LANDING_SELECTION ? 'main' : this.state.selection.name}
            />
          )}
        </div>
      </div>
    ) : null
  }
}

function Header (props) {
  return (
    <div className='assistant-mobile-header'>
      <div className='assistant-mobile-nav' style={{ position: 'relative' }}>
        <table style={{ width: '99%' }}>
          <tbody>
            <tr>
              {props.selection !== LANDING_SELECTION &&
                <td style={{
                  width: '15%',
                  paddingLeft: '12px',
                  border: '0px solid red',
                  fontSize: '18px'
                }}
                >
                  <span
                    className='fa fa-arrow-left fa-lg'
                    onClick={props.onBack}
                  />
                </td>}
              {props.selection !== LANDING_SELECTION &&
                <td style={{ border: '0px solid blue', textAlign: 'center' }}>
                  <span
                    onClick={props.onHome}
                  >Start Over
                  </span>
                </td>}
              <td style={{
                width: '15%',
                border: '0px solid green',
                textAlign: 'right',
                paddingRight: '20px',
                fontSize: '18px'
              }}
              >
                <span
                  className='fa fa-close fa-lg'
                  onClick={props.onClose}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='assistant-mobile-content'>
        <hr style={{ margin: '8px 0px 5px 0px' }} />
      </div>
    </div>
  )
}

function mapStateToProps (state) {
  return {
    pageContent: state.pageContent,
    permissions: state.permissions,
    referenceData: state.referenceData.filter(function (item) {
      return item.type === 'REF_DATA'
    })[0]
  }
}

export default connect(mapStateToProps, { setAssistantActive }, null, { withRef: true })(BotAssistantMobile)



// WEBPACK FOOTER //
// ./src/mi-app/digitalAssistant/BotAssistantMobile.js